import Meta from '@/components/common/Meta'

import ShipLuggageToStorageFacilityPage from '@/v2/components/pages/landing-pages/ship-luggage-to-storage-facility-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/ship-luggage-to-storage-facility-page'

interface ShipLuggageToStorageFacilityPageProps {}

const Page: React.FC<ShipLuggageToStorageFacilityPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.ship_luggage_to_storage_facility.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.ship_luggage_to_storage_facility?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.ship_luggage_to_storage_facility?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <ShipLuggageToStorageFacilityPage />
    </>
  )
}

export default Page
